<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <Main/>
  </div>
</template>

<script>
import Main from './components/Main'

export default {
  name: 'App',
  components: {
    Main
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue